// Device-level display & accessibility preferences. Applied to <html> so rem-based
// Tailwind sizing scales app-wide, plus reduce-motion / high-contrast body classes.
const FONT_KEY = "ps_font_size";
const MOTION_KEY = "ps_reduce_motion";
const CONTRAST_KEY = "ps_high_contrast";

const FONT_PX = { small: 14, normal: 16, large: 18 };

export function getFontSize() {
  return localStorage.getItem(FONT_KEY) || "normal";
}
export function setFontSize(size) {
  const s = FONT_PX[size] ? size : "normal";
  localStorage.setItem(FONT_KEY, s);
  document.documentElement.style.fontSize = `${FONT_PX[s]}px`;
  return s;
}

export function getReduceMotion() {
  return localStorage.getItem(MOTION_KEY) === "on";
}
export function setReduceMotion(on) {
  localStorage.setItem(MOTION_KEY, on ? "on" : "off");
  document.documentElement.classList.toggle("reduce-motion", !!on);
  return !!on;
}

export function getHighContrast() {
  return localStorage.getItem(CONTRAST_KEY) === "on";
}
export function setHighContrast(on) {
  localStorage.setItem(CONTRAST_KEY, on ? "on" : "off");
  document.documentElement.classList.toggle("high-contrast", !!on);
  return !!on;
}

const FONT_FACE_KEY = "ps_readable_font";
export function getReadableFont() {
  return localStorage.getItem(FONT_FACE_KEY) === "on";
}
export function setReadableFont(on) {
  localStorage.setItem(FONT_FACE_KEY, on ? "on" : "off");
  document.documentElement.classList.toggle("readable-font", !!on);
  return !!on;
}

// Apply all saved prefs immediately (called once at app boot).
export function initPrefs() {
  setFontSize(getFontSize());
  setReduceMotion(getReduceMotion());
  setHighContrast(getHighContrast());
  setReadableFont(getReadableFont());
}
